import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TDMaterialModule } from './td.material.module';
import { APP_BASE_HREF } from '@angular/common';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgStringPipesModule } from 'angular-pipes';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxFileDropModule } from 'ngx-file-drop';
import { CookieModule } from 'ngx-cookie';
import { fas, faBook, faClipboardList, faPollH, faFileSignature, faInbox, faFile,
  faSortAmountDown, faArrowDown, faArrowUp, faEllipsisV, faUser,
  faAddressCard, faChevronCircleRight, faInfoCircle, faEnvelope, faEnvelopeOpenText,
  faPrint, faCalendarDay, faTimes, faTasks, faEye, faPencilAlt,
  faSyncAlt, faCopy, faEraser, faPlus, faGlasses, faCommentAlt, faEdit,
  faMap, faSms, faGlobe, faExchangeAlt, faLink, faPlaneArrival, faPlaneDeparture,
  faMapMarkerAlt, faRedo, faFilter, faChevronDown, faLock, faMailBulk, faClone,
  faExternalLinkSquareAlt, faTrashAlt, faSearch, faDesktop, faExclamationCircle, faCheck, faCaretSquareLeft,
  faSignOutAlt,faCaretLeft,faCaretRight, faAsterisk, faCertificate, faRedoAlt,
  faFlask, faStar, faCog, faCogs, faUserPlus, faPencilRuler, faCaretUp, faCaretDown, faMinus,
  faHome, faUserFriends, faUserCircle, faUsers, faDownload, faPhone, faUniversity } from '@fortawesome/free-solid-svg-icons';
import { faCreditCard, faCalendar, faStickyNote, faTimesCircle, faCircle, faSave as farSave,
  faEdit as farEdit, faCircle as farCircle, faCheckCircle as farCheckCircle, faTimesCircle as farTimesCircle, faWindowMaximize as farWindowMaximize,
  faWindowRestore as farWindowRestore, faSquare as farSquare, faCheckSquare as farCheckSquare, faStar as farStar, faUserCircle as farUserCircle, 
faThumbsUp as farThumbsUp, faThumbsDown as farThumbsDown } from '@fortawesome/free-regular-svg-icons';
import { TopbarModule, NavigationModule, LoadingModule, LoadingErrorsModule, CommonComponentsModule, PipesModule } from '@terradotta/commons';
import { environment } from '../environments/environment';
import {
  SiteService,
  OauthService,
  ErrorConsoleService,
  AccountSettingService,
  ProgramTypeService,
  ProgramGroupService,
  TermService,
  ApplicationService,
  ImageService,
  UserService,
  TagService,
  TdsApiInterceptor,
  LookupTableService,
  LocationService,
  ApplicationDocumentService,
  ApplicationStatusService,
  NotificationsService,
  ProgramService,
  GooglePlacesService,
  WorkflowService,
  ProgramParameterService,  
  LanguagesService,
  AppcycleService,
  SisService,
} from '@terradotta/commons';
import { AgmCoreModule } from '@agm/core';
import { AppComponent } from './app.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { LoginModule } from './login/login.module';
import { SessionService } from '@terradotta/commons';

const appRoutes: Routes = [
  {path: 'index.cfm', component: AppComponent},
  {path: '', redirectTo: 'index.cfm', pathMatch: 'full'}
];

const appSettings = {
  API_URL: environment.TDS_URL + '/models/services/REST/index.cfm?endpoint=',
  IMAGE_URL: environment.TDS_URL + '/_customtags/ct_Image.cfm?Image_ID=',
  FILE_RETRIEVE_URL: environment.TDS_URL + '/_customtags/ct_FileRetrieve.cfm?File_ID=',
  DOCUMENT_RETRIEVE_URL: environment.TDS_URL + '/_customtags/ct_DocumentRetrieve.cfm?token=',
  TDS_URL: environment.TDS_URL,
  OAUTH_ENABLE: environment.oAuthEnabled,
  assetsFolder: environment.assetsFolder,
  googleAPIKey: environment.googleAPIKey,
  disableRuleDeploymentActivation: environment.disableRuleDeploymentActivation,
  showBetaWarnings: environment.showBetaWarnings,
  showAnalyticsLinkOnlyForSuperUsers: environment.showAnalyticsLinkOnlyForSuperUsers,
  production: environment.production,
  testUserName: environment.testUserName,
  testUserPassword: environment.testUserPassword
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
    FormsModule,
    ReactiveFormsModule,
    TDMaterialModule,
    TopbarModule,
    PipesModule,
    NavigationModule,
    LoadingModule,
    LoadingErrorsModule,
    CommonComponentsModule,
    FontAwesomeModule,
    NgStringPipesModule,    
    CKEditorModule,    
    NgxMatSelectSearchModule,    
    NgxFileDropModule,
    LoginModule,
    CookieModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: appSettings.googleAPIKey,
      libraries: ["places"]
    })
  ],
  providers: [
    SiteService,
    OauthService,
    ErrorConsoleService,
    AccountSettingService,
    ProgramTypeService,
    ProgramGroupService,
    TermService,
    ApplicationService,
    ImageService,
    UserService,
    TagService,
    LookupTableService,
    LocationService,
    ApplicationDocumentService,
    ApplicationStatusService,
    NotificationsService,
    ProgramService,
    GooglePlacesService,
    WorkflowService,
    ProgramParameterService,
    LanguagesService,
    AppcycleService,
    SisService,
    SessionService,
    {provide: APP_BASE_HREF, useValue : '/' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TdsApiInterceptor,
      multi: true
    },
    {
      provide: 'ApiScope',
      useValue: 'LoggedInUser'
    },
    {
      provide: 'appSettings',
      useValue: appSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIconPacks(fas);
    library.addIcons(
      faBook,
      faClipboardList,
      faPollH,
      faFileSignature,
      faInbox,
      faFile,
      faCreditCard,
      faSortAmountDown,
      faArrowDown,
      faArrowUp,
      faEllipsisV,
      faUser,
      faAddressCard,
      faChevronCircleRight,
      faInfoCircle,
      faEnvelope,
      faEnvelopeOpenText,
      faPrint,
      faCalendarDay,
      faEdit,
      faCalendar,
      faTimes,
      faTasks,
      faStickyNote,
      faTimesCircle,
      faEye,
      faPencilAlt,
      faSyncAlt,
      faCopy,
      faEraser,
      faPlus,
      faGlasses,
      faCommentAlt,
      faMap,
      faSms,
      faGlobe,
      faExchangeAlt,
      faLink,
      faCircle,
      farEdit,
      faPlaneArrival,
      faPlaneDeparture,
      faMapMarkerAlt,
      faRedo,
      faFilter,
      faChevronDown,
      faLock,
      faMailBulk,
      faClone,
      faExternalLinkSquareAlt,
      faTrashAlt,
      faPlus,
      faSearch,
      faDesktop,
      faExclamationCircle,
      faCheck,
      farSave,
      faCaretSquareLeft,
      faSignOutAlt,
      faCaretLeft,
      faCaretRight,
      farCheckCircle,
      faAsterisk,
      faCertificate,
      faRedoAlt,
      farWindowRestore,
      farWindowMaximize,
      faFlask,
      farCheckSquare,
      farSquare,
      faStar,
      farStar,
      faCog,
      faCogs,
      faUserPlus,
      faPencilRuler,
      faCaretUp,
      faCaretDown,
      faMinus,
      faHome,
      faUserFriends,
      faUserCircle,
      faUsers,
      farUserCircle,
      farThumbsDown,
      farThumbsUp,
      faDownload,
      faPhone, 
      faUniversity,
      farTimesCircle
    );
  }
}

